<template>
  <div class="block">
    <div class="title">{{title}}</div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Block",
  props: {
    title: String,
  }
}
</script>

<style lang="less" scoped>
.block{
  .title{
    color: rgb(0, 173, 116);
    font-size: 24px;
    font-weight: bold;
  }
  .content{

  }
}
</style>